import axiosInstance from "../libs/axiosInstance";

//  * Get public courses list (paginated)
export const getPublicCourses = async ({
  search_text=null, 
  department_id=null, 
  faculty_id=null, 
  level=null,
  url=null,
  include_topics=null,
  include_my=null,
}={}) => {
  try {
    const params = {
      ...(search_text && { search: search_text }),
      ...(department_id && { department_id }),
      ...(faculty_id && { faculty_id }),
      ...(include_topics && { include_topics: 1 }),
      ...(include_my && { include_my: 1 }),
      ...(level && { level })
    };
    
    const response = await axiosInstance.get(url || '/course_management/public/courses/', {
      params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching public courses:', error);
    throw error;
  }
};

// * Get public courses for select/dropdown (non-paginated)
export const getPublicCoursesSelect = async ({
  search_text=null,
  include_my=null,
}={}) => {
  try {
    const params = {
      ...(search_text && { search: search_text }),
      ...(include_my && { include_my: 1 }),
    };
    
    const response = await axiosInstance.get('/course_management/public/courses/select/', {
      params
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching public courses for select:', error);
    throw error;
  }
};

// * Get public course details
export const getPublicCourseDetail = async (courseId) => {
  try {
    const response = await axiosInstance.get(`/course_management/public/courses/${courseId}/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching public course detail:', error);
    throw error;
  }
};